import {useLocation, useNavigate} from "react-router-dom";
import {useBoundStore} from "e3-common/store/useBoundStore";
import {useEffect} from "react";
const ExpiredCheckRoute = ({children}) => {
    const location = useLocation();
    const {expiredCheck,userId} = useBoundStore((state) => state.user);
    const navigate = useNavigate();
    // 로그인 유효기간이 만료되었는지 확인

    useEffect(() => {
        if(userId && expiredCheck === 'Y') {
            navigate(`${import.meta.env.VITE_PUBLIC_URL}/pwChange`,{replace:true});
        }
    }, [userId,expiredCheck,location.pathname,navigate]);

    return children;

}

export default ExpiredCheckRoute;